import { c as _c } from "react/compiler-runtime";
import { fillVariants } from "../../../styles/utils/fill";
export function SolanaLogo(t0) {
  const $ = _c(18);
  let className;
  let rest;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      className,
      fill: t1,
      fillAttribute: t2,
      size: t3,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const fill = t1 === undefined ? "current" : t1;
  const fillAttribute = t2 === undefined ? "currentColor" : t2;
  const size = t3 === undefined ? 24 : t3;
  let t4;
  if ($[6] !== size) {
    t4 = {
      width: size,
      height: size
    };
    $[6] = size;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== fill) {
    t5 = fillVariants({
      fill
    });
    $[8] = fill;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== fillAttribute || $[11] !== t5) {
    t6 = <path className={t5} d="m23.876 18.032-3.962 4.14a.92.92 0 0 1-.673.284H.46a.469.469 0 0 1-.252-.074.437.437 0 0 1-.084-.68l3.965-4.14a.92.92 0 0 1 .67-.284H23.54a.47.47 0 0 1 .252.073.438.438 0 0 1 .084.68Zm-3.962-8.336a.92.92 0 0 0-.673-.285H.46a.469.469 0 0 0-.252.074.438.438 0 0 0-.084.68l3.965 4.14a.92.92 0 0 0 .67.284H23.54a.453.453 0 0 0 .422-.27.438.438 0 0 0-.086-.483l-3.962-4.14ZM.46 6.723h18.781a.942.942 0 0 0 .673-.285l3.962-4.14a.444.444 0 0 0 .086-.484.453.453 0 0 0-.17-.196.469.469 0 0 0-.252-.073H4.76a.94.94 0 0 0-.671.285L.125 5.97a.444.444 0 0 0-.086.483.469.469 0 0 0 .421.27Z" fill={fillAttribute} />;
    $[10] = fillAttribute;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== className || $[14] !== rest || $[15] !== t4 || $[16] !== t6) {
    t7 = <svg className={className} style={t4} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t6}</svg>;
    $[13] = className;
    $[14] = rest;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}